module.exports = __webpack_public_path__ + "static/media/1.3.1-dashboard-group-act.12096013.jpg";